import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaUpload } from "react-icons/fa";
import { apiputFormData, Get_Api } from "../../API/Api_Url";
import { toast } from "react-toastify";
import LocationMap from "./LocationMap";

const UpdateRequirementModal = ({ requirementData, isOpen, onClose, GetUserAllPendingRequirements }) => {
    const [ProjectType, setProjectType] = useState("");
    const [SizeDimension, setSizeDimension] = useState({
        Length: "",
        Breadth: "",
        Unit: "",
        Area: ""
    });
    const [NumberOfFloors, setNumberOfFloors] = useState("");
    const [State, setState] = useState("");
    const [City, setCity] = useState("");
    const [Pincode, setPincode] = useState("");
    const [LocationAddress, setLocationAddress] = useState("");
    const [Latitude, setLatitude] = useState('786.7809');
    const [Longitude, setLongitude] = useState('67.899');
    const [Budget, setBudget] = useState("");
    const [PaymentMethod, setPaymentMethod] = useState("");
    const [TimelineInMonths, setTimelineInMonths] = useState("");
    const [NeedLocalAuthorityApproval, setNeedLocalAuthorityApproval] = useState("");
    const [Images, setImages] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);

    const [AllProjectType, setAllProjectType] = useState([]);

    const getAllProjectType = async () => {
        try {
            setIsLoading(true);
            const response = await Get_Api("api/admin/GetAllProjectType");
            setAllProjectType(response?.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message);
            console.error(error);
        }
    };

    useEffect(() => {
        getAllProjectType();
    }, []);


    useEffect(() => {
        if (requirementData) {
            setProjectType(requirementData.ProjectType || "");
            setSizeDimension({
                Length: requirementData?.SizeDimension?.Length || "",
                Breadth: requirementData?.SizeDimension?.Breadth || "",
                Unit: requirementData?.SizeDimension?.Unit || "",
                Area: requirementData?.SizeDimension?.Area || ""
            });
            setNumberOfFloors(requirementData.NumberOfFloors || "");
            setState(requirementData.State || "");
            setCity(requirementData.City || "");
            setPincode(requirementData.Pincode || "");
            setLocationAddress(requirementData.Location?.Address || "");
            setLatitude(requirementData.Location?.Late || "");
            setLongitude(requirementData.Location?.Long || "");
            setBudget(requirementData.Budget || "");
            setPaymentMethod(requirementData.PaymentMethod || "");
            setTimelineInMonths(requirementData.TimelineInMonths || "");
            setNeedLocalAuthorityApproval(requirementData.NeedLocalAuthorityApproval || false);
            setImages(requirementData.SitePhotosOrPlan || []);
        }
    }, [requirementData]);


    const handleImageUpload = (e) => {
        setImages([...Images, ...Array.from(e.target.files)]);
    };

    const removeImage = (index) => {
        setImages(Images.filter((_, i) => i !== index));
    };

    const [errors, setErrors] = useState({});

    const handleUpdateRequirementSubmit = async () => {
        let newErrors = {};
        if (!ProjectType) newErrors.ProjectType = "Project Type is required";
        if (!SizeDimension.Length) newErrors.Length = "Length is required";
        if (!SizeDimension.Breadth) newErrors.Breadth = "Breadth is required";
        if (!SizeDimension.Unit) newErrors.Unit = "Unit is required";
        if (!SizeDimension.Area) newErrors.Area = "Area is required";
        if (!NumberOfFloors || isNaN(NumberOfFloors)) newErrors.NumberOfFloors = "Number of Floors is required";
        if (!State) newErrors.State = "State is required";
        if (!City) newErrors.City = "City is required";
        if (!Pincode) newErrors.Pincode = "Pincode is required";
        if (!LocationAddress) newErrors.LocationAddress = "Location Address is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true);

            const formData = new FormData();
            formData.append("ProjectType", ProjectType);
            formData.append("SizeDimension[Length]", SizeDimension.Length);
            formData.append("SizeDimension[Breadth]", SizeDimension.Breadth);
            formData.append("SizeDimension[Unit]", SizeDimension.Unit);
            formData.append("SizeDimension[Area]", SizeDimension.Area);
            formData.append("NumberOfFloors", NumberOfFloors);
            formData.append("State", State);
            formData.append("City", City);
            formData.append("Pincode", Pincode);
            formData.append("Location[Address]", LocationAddress);
            formData.append("Location[Late]", Latitude);
            formData.append("Location[Long]", Longitude);
            formData.append("Budget", Budget);
            formData.append("PaymentMethod", PaymentMethod);
            formData.append("TimelineInMonths", TimelineInMonths);
            formData.append("NeedLocalAuthorityApproval", NeedLocalAuthorityApproval);


            Images.forEach((img) => {
                formData.append("Image", img);
            });

            const response = await apiputFormData(`/api/user/UpdateUserConstructionRequirement/${requirementData?._id}`, formData);

            if (response?.data) {
                toast.success("Requirement updated successfully!");
                onClose()
                GetUserAllPendingRequirements();
            } else {
                toast.error(response?.message || "Failed to update requirement");
            }
        } catch (error) {
            console.error("Error updating requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const length = Number(SizeDimension.Length);
        const breadth = Number(SizeDimension.Breadth);
        const floors = Number(NumberOfFloors);

        if (length > 0 && breadth > 0 && floors > 0) {
            let area = length * breadth * floors;

            let areaString

            if (SizeDimension.Unit === "sq. m.") {
                areaString = `${area} sq. m.`;
            }
            if (SizeDimension.Unit === "sq. ft.") {
                areaString = `${area} sq. ft.`;
            }

            setSizeDimension((prev) => ({
                ...prev,
                Area: areaString
            }));
        } else {
            setSizeDimension((prev) => ({
                ...prev,
                Area: ""
            }));
        }
    }, [SizeDimension.Length, SizeDimension.Breadth, SizeDimension.Unit, NumberOfFloors]);



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-semibold text-gray-800">Update Requirement</h2>
                </div>

                <div className="grid grid-cols-1 gap-5 pt-5">
                    <div>
                        <label className="block mb-1 font-medium">Project Type <span className="text-red-500">*</span></label>
                        <select
                            className={`form-input w-full ${errors?.ProjectType ? "border-red-500" : ""}`}
                            value={ProjectType}
                            onChange={(e) => setProjectType(e.target.value)}
                        >
                            <option value="">Select Project Type</option>
                            {AllProjectType?.map((type) => (
                                <option key={type?._id} value={type?.Name}>
                                    {type?.Name}
                                </option>
                            ))}
                        </select>
                        {errors?.ProjectType && <p className="text-red-500 text-sm mt-1">{errors?.ProjectType}</p>}
                    </div>

                    <label className="block font-medium">Size / Dimension</label>
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                        <div>
                            <label className="block mb-1 font-medium">Length<span className="text-red-500">*</span></label>
                            <input
                                type="number"
                                placeholder="Length"
                                className={`form-input w-full ${errors?.Length ? "border-red-500" : ""}`}
                                value={SizeDimension.Length}
                                onChange={(e) =>
                                    setSizeDimension({ ...SizeDimension, Length: e.target.value })
                                }
                            />
                            {errors?.Length && <p className="text-red-500 text-sm mt-1">{errors?.Length}</p>}
                        </div>

                        <div>
                            <label className="block mb-1 font-medium">Breadth<span className="text-red-500">*</span></label>
                            <input
                                type="number"
                                placeholder="Breadth"
                                className={`form-input w-full ${errors?.Breadth ? "border-red-500" : ""}`}
                                value={SizeDimension.Breadth}
                                onChange={(e) =>
                                    setSizeDimension({ ...SizeDimension, Breadth: e.target.value })
                                }
                            />
                            {errors?.Breadth && <p className="text-red-500 text-sm mt-1">{errors?.Breadth}</p>}
                        </div>

                        <div>
                            <label className="block mb-1 font-medium">Number of Floors<span className="text-red-500">*</span></label>
                            <input
                                type="number"
                                placeholder="Floors"
                                className={`form-input w-full ${errors?.NumberOfFloors ? "border-red-500" : ""}`}
                                value={NumberOfFloors}
                                onChange={(e) => setNumberOfFloors(e.target.value)}
                            />
                            {errors?.NumberOfFloors && <p className="text-red-500 text-sm mt-1">{errors?.NumberOfFloors}</p>}
                        </div>
                        <div>
                            <label className="block mb-1 font-medium">Unit <span className="text-red-500">*</span></label>
                            <select
                                className={`form-input w-full ${errors?.Unit ? "border-red-500" : ""}`}
                                value={SizeDimension.Unit}
                                onChange={(e) =>
                                    setSizeDimension({ ...SizeDimension, Unit: e.target.value })
                                }
                            >
                                <option value="">Unit</option>
                                <option value="sq. ft.">sq. ft.</option>
                                <option value="sq. m.">sq. m.</option>
                            </select>
                            {errors?.Unit && <p className="text-red-500 text-sm mt-1">{errors?.Unit}</p>}
                        </div>


                        <div>
                            <label className="block mb-1 font-medium">Area<span className="text-red-500">*</span></label>
                            <input
                                className={`form-input w-full ${errors?.Area ? "border-red-500" : ""}`}
                                type="text"
                                placeholder="Area"
                                value={SizeDimension.Area}
                                readOnly
                            />
                            {errors?.Area && <p className="text-red-500 text-sm mt-1">{errors?.Area}</p>}
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5 mt-2">
                    <div>
                        <label className="block mb-1 font-medium">Budget</label>
                        <select
                            className="form-input w-full"
                            value={Budget}
                            onChange={(e) => setBudget(e.target.value)}
                        >
                            <option value="">Select Budget</option>
                            {Array.from({ length: 20 }, (_, i) => {
                                const start = i * 5;
                                const end = (i + 1) * 5;
                                return (
                                    <option key={i} value={`${start}-${end} Lac`}>
                                        {start} - {end} Lac
                                    </option>
                                );
                            })}
                            <option value="100+ Lac">Above 1 Crore</option>
                        </select>
                    </div>


                    <div>
                        <label className="block mb-1 font-medium">Payment Method</label>
                        <select
                            className="form-input w-full"
                            value={PaymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                            <option value="">Select Payment Method</option>
                            <option value="Milestone">Milestone</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Invoice-based Payment">Invoice-based Payment</option>
                        </select>
                    </div>
                    <div className="relative group">
                        <label className="block mb-1 font-medium flex items-center gap-2">
                            Timeline (Months)
                            <span className="text-gray-400 cursor-pointer">ℹ️</span>
                        </label>
                        <select
                            className="form-input w-full"
                            value={TimelineInMonths}
                            onChange={(e) => setTimelineInMonths(e.target.value)}
                        >
                            <option value="">Select Timeline</option>
                            <option value="0-2">0 - 2 Months</option>
                            <option value="2-4">2 - 4 Months</option>
                            <option value="4-6">4 - 6 Months</option>
                            <option value="6-12">6 - 12 Months</option>
                            <option value="12+">Above 12 Months</option>
                        </select>

                        <div className="absolute left-0 mt-1 hidden w-max max-w-xs rounded-lg bg-gray-800 px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                            Select the estimated time you expect the project to take.
                        </div>
                    </div>

                    <div className="relative group">
                        <label className="block mb-1 font-medium flex items-center gap-2">
                            Need Local Authority Approval
                            <span className="text-gray-400 cursor-pointer">ℹ️</span>
                        </label>
                        <select
                            className="form-input w-full"
                            value={NeedLocalAuthorityApproval}
                            onChange={(e) => setNeedLocalAuthorityApproval(e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                        </select>
                        <div className="absolute left-0 mt-1 hidden w-max max-w-xs rounded-lg bg-gray-800 px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                            Specify whether government or municipal approval is required for this project.
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-2 font-medium">Select Your Location</label>
                        <div className="w-full rounded-lg border p-3 shadow-sm">
                            <LocationMap
                                setLatitude={setLatitude}
                                setLongitude={setLongitude}
                                setLocationAddress={setLocationAddress}
                                setCity={setCity}
                                setState={setState}
                                setPincode={setPincode}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">State <span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.State ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter State"
                            value={State}
                            onChange={(e) => setState(e.target.value)}
                        />
                        {errors?.State && <p className="text-red-500 text-sm mt-1">{errors?.State}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">City <span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.City ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter City"
                            value={City}
                            onChange={(e) => setCity(e.target.value)}
                        />
                        {errors?.City && <p className="text-red-500 text-sm mt-1">{errors?.City}</p>}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Pincode <span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.Pincode ? "border-red-500" : ""}`}
                            type="number"
                            placeholder="Enter Pincode"
                            value={Pincode}
                            onChange={(e) => setPincode(e.target.value)}
                        />
                        {errors?.Pincode && <p className="text-red-500 text-sm mt-1">{errors?.Pincode}</p>}
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">Address <span className="text-red-500">*</span></label>
                        <input
                            className={`form-input w-full ${errors?.LocationAddress ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter Address"
                            value={LocationAddress}
                            onChange={(e) => setLocationAddress(e.target.value)}
                        />
                        {errors?.LocationAddress && <p className="text-red-500 text-sm mt-1">{errors?.LocationAddress}</p>}
                    </div>
                </div>
                <div className="mt-6 pt-4">
                    <label className="block mb-2 font-medium">Project Images</label>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {Images.map((img, index) => (
                            <div key={index} className="relative">
                                <img
                                    src={typeof img === "string" ? img : URL.createObjectURL(img)}
                                    alt="Preview"
                                    className="h-28 w-full object-cover rounded-lg border"
                                />
                                <button
                                    type="button"
                                    onClick={() => removeImage(index)}
                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 text-xs"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}

                        <label className="cursor-pointer">
                            <UploadBox label="Add Image" />
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                className="hidden"
                                onChange={handleImageUpload}
                            />
                        </label>
                    </div>
                </div>

                <button
                    onClick={handleUpdateRequirementSubmit}
                    disabled={IsLoading}
                    className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
          ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"}`}
                >
                    {IsLoading ? "Updating..." : "Update Requirement"}
                </button>
            </div>
        </div>
    );
};

const UploadBox = ({ label }) => (
    <div className="border-dashed border-2 border-gray-300 rounded-lg h-28 flex flex-col items-center justify-center hover:border-blue-400 transition">
        <FaUpload className="text-gray-500 mb-2" />
        <span className="text-gray-700 font-medium">{label}</span>
    </div>
);

export default UpdateRequirementModal;
